<template>
    <div>
        <h2>{{slide.type}} Data:</h2>
        <!--<hr>
        <quill-editor 
            @blur="saveSlide()"
            v-model="slide.slide.corpus"
            :options="{'placeholder': 'Write prompt here (optional)'}"
        ></quill-editor>-->
        <hr>
        <div>
            <md-card style="margin: auto; display: inline-block; padding: 20px;">
                <h3 style="margin-top: 0px; margin-bottom: 10px">
                    Instructions:
                </h3>
                <span style="font-size: 110%; text-align: justify; float: left;">
                    - Create test panels for the learner to choose from (like a complete blood count or a chest X-ray).
                    <br>
                    - Test panels can be designated as: necessary for diagnosis, low value, or neither.
                    <br>
                    - Cost data will be automatically suggested for known diagnosis based on 2018 Medicare data.
                    <br>
                    - A search engine can be used to find HCPCS codes if a suggestion is not found. 
                </span>
            </md-card>
            <br>
            <hr>
        </div>

        <draggable :list="slide.panels" @start="drag=true" @end="drag=false" @update="checkMove">
            <md-card v-for="(panel, panelIndex) in slide.panels" :key="panel.id" class="lab-panel" :style="{'background-color': panel.should_order ? '#f3fff2' : (panel.should_not_order ? '#fff2f2' : 'white')}">
                <div style="cursor: move">
                    <b>Panel #{{panelIndex+1}}:</b>
                    {{panel.name}} 
                    <div v-if="panel.cost" style="margin-top: 6px;"><i>Cost: ${{panel.cost}}</i></div>
                    <span v-if="panel.should_order">
                        <i>Necessary Lab</i>
                    </span>
                    <span v-if="panel.should_not_order">
                        <i>Low-Value Lab</i>
                    </span>
                </div>
                <div class="lab-panel-btns">
                    <md-button class="md-icon-button md-dense md-primary md-raised" @click="editPanel(panelIndex)">
                        <md-icon>edit</md-icon>
                    </md-button>
                    <br>
                </div>
            </md-card>
        </draggable>
        <md-button class="md-primary md-raised" jest="add-panel-btn" @click="openPanelCreator()" style="margin-top: 20px">
            Add Panel
        </md-button>
        <hr>
        <md-button class="md-raised md-primary" @click="saveSlide(true)" style="background-color: green">
            Save
        </md-button>
        <md-button class="md-raised md-accent md-icon-button slide-delete-btn" @click="deleteSlide()">
            <md-icon>delete_forever</md-icon>
        </md-button>
        <!-- Panel create dialog box -->
        <md-dialog v-show="!showInactivityDialog" :md-active="showPanelCreator" style="width: 700px; max-width: 100%;" :class="{'vertical-layout': useVerticalLayout}">
            <md-dialog-title>Panel Creator</md-dialog-title>
            <md-dialog-content class="creator-dialog-content">
                <md-tabs>
                    <md-tab md-label="New Panel">
                        <md-field>
                            <span v-show="newPanel.name && newPanel.name.trim().length > 0" style="color: rgba(0,0,0,0.54); font-size: 12px; position: absolute; top: -5px;">
                                Panel Name
                            </span>
                            <vue-simple-suggest
                            placeholder="Panel Name - HCPCS"
                            @input="(e) => {newPanel.name = e; if(Object.keys(costData).includes(e)){newPanel.cost = costData[e].cost.toFixed(2)}}"
                            :list="Object.keys(costData)"
                            :max-suggestions=1000
                            :min-length=2
                            :filter-by-query="true">
                                <template slot="misc-item-above" slot-scope="{ suggestions, query }">
                                    <!-- Sub-template if have any suggestions -->
                                    <template v-if="suggestions.length > 0">
                                        <div class="misc-item" style="margin-top: 10px;">
                                        <span>{{ suggestions.length }} suggestions are shown for '{{ query }}'</span>
                                        </div>
                                        <hr>
                                    </template>
                                    <!-- Show "No result" otherwise -->
                                    <div class="misc-item" v-else>
                                        <span><a target="_blank" :href="constructHcpcsSearch(query)">
                                            No results found, search for HCPCS code?
                                        </a></span>
                                    </div>
                                </template>
                            </vue-simple-suggest>
                        </md-field>
                        <md-field>
                            <label>Panel Cost (in USD)</label>
                            <md-input v-model="newPanel.cost" type="number"></md-input>
                        </md-field>
                        <div style="width: 86%; text-align: center; font-style: italic; margin: auto; font-size: 85%; margin-top: -10px;">
                            Cost estimates are available for many tests using <a href="http://economed.jpoles1.com" target="_blank">Medicare data from 2018</a>.
                            <br>
                            If you cannot find what you are looking for, trying searching Google for the HCPCS code or search <a href="https://www.questdiagnostics.com/testcenter/TestCenterHome.action" target="_blank">here</a>.
                        </div>
                        <hr>
                        <center>
                            <b>Flip the switch below if this panel is necessary to reach the correct diagnosis:</b>
                            <br>
                            <md-switch 
                            class="md-primary"
                            v-model="newPanel.should_order"
                            @change="newPanel.should_not_order = newPanel.should_order ? false : newPanel.should_not_order">
                                Necessary Lab    
                            </md-switch>
                            <br><br>
                            <b>Flip the switch below if this panel is of low value in this case:</b>
                            <br>
                            <md-switch 
                            class="md-primary"
                            v-model="newPanel.should_not_order"
                            @change="newPanel.should_order = newPanel.should_not_order ? false : newPanel.should_order">
                                Low Value Lab
                            </md-switch>
                            <hr>
                            <md-button class="md-primary md-raised md-dense" @click="addPanel()">
                                Create Lab Panel
                            </md-button>

                        </center>
                    </md-tab>
                    <md-tab md-label="Use Preset">
                        <PresetList :addLabsMode="true" @addPresetsToSlide="addPresetsToSlide" @notify="(x) => $emit('notify', x)"/>
                    </md-tab>
                </md-tabs>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary md-dense" @click="newPanel={}; showPanelCreator=false">
                    Cancel
                </md-button>
            </md-dialog-actions>
        </md-dialog>
        <!-- Panel edit dialog box -->
        <md-dialog v-show="!showInactivityDialog" :md-active="showPanelEditor" :class="{'vertical-layout': useVerticalLayout}">
            <md-dialog-title>Panel Editor</md-dialog-title>
            <md-dialog-content>
                <md-speed-dial class="md-top-right" md-direction="bottom" md-event="click">
                    <div>
                        <md-speed-dial-target class="md-primary md-mini">
                            <md-icon class="md-morph-initial">settings</md-icon>
                            <md-icon class="md-morph-final">close</md-icon>
                        </md-speed-dial-target>
                        <md-tooltip md-direction="left">
                            Panel Settings
                        </md-tooltip>
                    </div>
                    <md-speed-dial-content>
                        <div>
                            <md-button class="md-icon-button md-raised" @click="savePanelAsPreset">
                                <md-icon>save</md-icon>
                            </md-button>
                            <md-tooltip md-direction="left">
                                Save Preset
                            </md-tooltip>
                        </div>
                        <div>
                            <md-button class="md-accent md-icon-button" @click="deletePanel(activePanel.info.order-1)">
                                <md-icon>cancel</md-icon>
                            </md-button>
                            <md-tooltip md-direction="left">
                                Delete Panel
                            </md-tooltip>
                        </div>
                    </md-speed-dial-content>
                </md-speed-dial>
                <PanelEditor :costData="costData" :activePanel.sync="activePanel" v-if="showPanelEditor" v-on:saveSlide="saveSlide"/>
            </md-dialog-content>
            <md-dialog-actions>
                <!--<md-button class="md-accent md-raised" @click="deletePanel(activePanel.info.order-1)" style="position: absolute; left: 10px;">
                    Delete
                </md-button>-->
                <md-button class="md-primary" @click="closePanel()">
                    Close
                </md-button>
                <md-button class="md-primary md-raised" @click="savePanel()">
                    Save
                </md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
    import APIRequests from "../APIRequests.js"
    import PresetList from "../PresetList.vue"
    import PanelEditor from "./PanelEditor.vue"
    const ObjectID = require("bson-objectid");
    import draggable from 'vuedraggable'
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css' // Optional CSS

    export default {
        props: {
            useVerticalLayout: {
                type: Boolean
            },
            showInactivityDialog: {
                type: Boolean
            },
            slide: {
                type: Object
            },
            costData: {
                type: Object
            }
        },
        data: function(){
            return {
                activePanel: {},
                activePanelOriginal: {},
                showPanelEditor: false,
                newPanel: {},
                showPanelCreator: false,
            }
        },
        components: {
            PresetList,
            PanelEditor,
            VueSimpleSuggest,
            draggable,
        },
        methods: {
            savePanelAsPreset: function(){
                let abnormality = prompt("If this lab contains pathological findings please state the proximate cause (eg: elevated direct billirubin due to billiary obstruction). Otherwise leave blank.")
                if(abnormality.trim() == ""){
                    let confirm_msg = "Cause left blank. Please confirm addition of a normal lab preset:"
                    if(!confirm(confirm_msg)) return
                }
                let presetData = {
                    description: "",
                    abnormality: abnormality,
                    panel: this.activePanel,
                } 
                let api_url = this.$store.state.api_url + "/api/panelPresets/update"
                APIRequests.postJSONData(api_url, presetData, this.$store.state.jwtToken).then((data) => {
                    if(!data) data = {}
                    if(!data.presetID) throw "Missing preset ID in response from server"
                    alert("Preset saved sucessfully. If a new tab does not appear with the newly duplicated preset, please disable your popup blocker for this website. The new preset is also accessible in your user settings panel.")
                    var win = window.open("/settings/panel_presets?presetID=" + data.presetID, '_blank');
                    win.focus();
                }).catch(() => {
                    this.$emit("notify", "Failed to save panel preset.")
                })
            },
            addPresetsToSlide: function(presetsToAdd){
                if(!this.slide.panels) this.$set(this.slide, "panels", []);
                presetsToAdd.forEach((presetData) => {
                    presetData.info.order = this.slide.panels.length + 1
                    this.$set(this.slide.panels, this.slide.panels.length, presetData)
                })
                this.resetPanelOrder()
                this.saveSlide()
                this.addPresetList = []
                this.showPanelCreator = false;
            },
            constructHcpcsSearch: function(query){
                if(!query) return "#"
                return "https://duckduckgo.com/?q=hcpcs+" + query.replace(' ', '+')
            },
            /**
             * saveSlide emits an event which tells the parent component to save the data for this slide to the DB
             * @param {bool} closeSlide determines whether the slide editor will close after save.
            */
            saveSlide: function(closeSlide) {
                this.$emit('saveSlide', [this.slide, closeSlide])
            },
            deleteSlide: function(){
                this.$emit('deleteSlide', this.slide)
            },
            /**
             * resetPanelOrder recalculates the multiple choice option "order" value
            */
            resetPanelOrder: function(){
                if(!this.slide.panels) return
                for (var i = 0; i < this.slide.panels.length; i++) {
                    this.slide.panels[i].info.order = i+1
                }
            },
            /**
             * checkMove is ued to apply all the changes after an option is dragged
            */
            checkMove: function(){
                this.resetPanelOrder()
                this.saveSlide(false)
            },
            /**
             * editPanel opens a lab panel editing dialog for inputting results returned from lab testing
            */
            editPanel: function(panelIndex){
                this.activePanel = this.slide.panels[panelIndex]
                this.activePanelOriginal = JSON.parse(JSON.stringify(this.activePanel));
                this.showPanelEditor = true
            },
            /**
             * closePanel closes a lab panel editing dialog without saving the results 
            */
            closePanel: function(){
                this.showPanelEditor = false
                this.slide.panels[this.activePanelOriginal.info.order-1] = this.activePanelOriginal
                this.activePanel = {}
            },
            /**
             * savePanel 
            */
            savePanel: function(){
                this.activePanel.cost = parseFloat(this.activePanel.cost);
                this.saveSlide(); 
                this.showPanelEditor=false;
                this.activePanel = {}
            },
            /**
             * addPanel allows the user to add a lab panel
            */
            addPanel: function(){
                if(this.newPanel.name.trim().length < 1){
                    this.$emit("notify", "Cannot create a panel without a name.")
                    return
                }
                var id  = ObjectID();
                this.newPanel.id = id.toString();
                if(!this.slide.panels) this.$set(this.slide, "panels", []);
                this.newPanel.info = {
                    order: this.slide.panels.length + 1, 
                    resources: []
                }
                this.newPanel.cost = parseFloat(this.newPanel.cost);
                this.newPanel.results = []
                this.$set(this.slide.panels, this.slide.panels.length, JSON.parse(JSON.stringify(this.newPanel)))
                this.resetPanelOrder()
                this.newPanel = {}
                this.showPanelCreator = false;
                //Open new panel in editor
                this.editPanel(this.slide.panels.length-1)
                this.addPanelResult()
                this.editPanel(this.slide.panels.length-1)
                this.saveSlide()
            },
            /**
             * openPanelCreator opens the dialog for the user to add a lab panel
            */
            openPanelCreator: function(){
                this.newPanel = {name: "", cost: 0.0, should_order: false, should_not_order: false}
                this.showPanelCreator = true;
            },
            /**
             * deletePanel allows the user to delete a lab panel and all results contained therein
             * @param {int} panelIndex dictates the index of the panel to delete
            */
            deletePanel: function(panelIndex){
                var confirmDeletion = confirm("Are you sure you want to delete this panel and all results contained therein?")
                if(confirmDeletion){
                    this.slide.panels.splice(panelIndex, 1)
                    this.resetPanelOrder()
                    this.saveSlide();
                    this.showPanelEditor = false;
                }
            },
            /**
             * addPanelResult allows the user to create a new lab panel result.
            */
            addPanelResult: function(){
                var id  = ObjectID();
                var newResult = {
                    id: id.toString(),
                    name: "",
                    refRange: "",
                    value: ""
                }
                var updateable = this.slide.panels[this.activePanel.info.order-1]
                if(!updateable.results) updateable.results = [];
                updateable.results.push(newResult)
                this.$set(this.slide.panels, this.activePanel.info.order-1, updateable)
            },
        },
        mounted: function(){
            this.$nextTick(function(){
            })
        }
    }
</script>

<style scoped>
.md-field{
    max-width: 80%;
    margin: auto;
    margin-bottom: 40px;
}
.drag-handle{
    cursor: move;
    padding: 13px 20px 20px 40px;
}
.lab-panel{
    margin: 20px auto; 
    min-height: 60px; 
    text-align: left; 
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 110%;
    padding: 20px 60px 20px 20px;
}
.lab-panel-btns{
    position: absolute;
    right: 10px;
}
.md-dialog{
    overflow: auto;
}
.creator-dialog-content{
    padding: 0;
}
.md-dialog:not(.vertical-layout){
    max-width: 90% !important;
    max-height: 96% !important;
}
.md-tooltip{
    text-align: center;
    height:auto
}
div >>> .preset-table td{
    padding: 0px !important;
}
</style>
<style>
    .vue-simple-suggest{
        width: 100%;
    }
    .vue-simple-suggest .suggestions
    {
        max-height: 275px;
        overflow-y: auto;
    }
</style>